import React from 'react';
import PropTypes from 'prop-types';

import DeleteIcon from 'components/icons/DeleteIcon';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import EditIcon from 'components/icons/EditIcon';

const Actions = ({ onDelete, onUpdate }) => {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      <IconButton
        size="small"
        onClick={onUpdate}
      >
        <EditIcon />
      </IconButton>
      <IconButton
        onClick={onDelete}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};

Actions.propTypes = {
  onDelete: PropTypes.func,
  onUpdate: PropTypes.func,
};

export default Actions;
